<template>
  <Navbar />
  <SubNav></SubNav>
  <!-- <secondNav></secondNav> -->
  <main class="school-main">
    <div class="w-100">
      <slot></slot>
    </div>
  </main>
</template>

<script setup lang="ts">
import Navbar from "@/components/school/layout/Navbar.vue";
import SubNav from "@/components/school/layout/Subnav.vue";
import { useSchoolStore } from "@/stores/school";
import { watch } from "vue";
import { useRouter } from "vue-router";

const schoolStore = useSchoolStore();
const router = useRouter();
schoolStore.loadSchool();

watch(
  () => schoolStore.school,
  (newData) => {
    if (newData) {
      if (schoolStore.school?.expiration_date && schoolStore.isExpired()){
        router.push({ name: "expired-account" });
      }
    }
  },
  { immediate: true } // This ensures the watcher runs immediately with the initial value
);

//
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
// .school-main {
//   // flex: 1 1 auto !important;
//   // overflow: auto;
// }
</style>
